import { type JSX } from 'react';
import { Button } from '@mui/material';

import { googleSignInUrl } from '../api.js';

/**
 * "Continue with Google" — a single button that kicks off the server-driven
 * OAuth flow by navigating the whole page to `/auth/google/start`. There's no
 * client-side OAuth library and no token handling here: the licensing-server
 * does the full round-trip and lands the browser back on the Portal with a
 * session cookie already set (or an `?autherror=` the App surfaces).
 *
 * Login + one-click signup: Google signs into an *existing* MobiLauncher
 * account whose verified email matches, or — for an email we've never seen —
 * provisions a fresh Free tenant on the fly and lands the visitor in it. Only
 * an unverified Google email comes back as `?autherror=no_account`.
 */
export function GoogleSignInButton(props: { disabled?: boolean }): JSX.Element {
  return (
    <Button
      fullWidth
      variant="outlined"
      color="inherit"
      disabled={props.disabled === true}
      onClick={() => window.location.assign(googleSignInUrl)}
      data-testid="google-signin"
      startIcon={
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
          <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
          <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.34A9 9 0 0 0 9 18z" />
          <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.94H.96a9 9 0 0 0 0 8.12l3.01-2.34z" />
          <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.9 11.43 0 9 0A9 9 0 0 0 .96 4.94l3.01 2.34C4.68 5.16 6.66 3.58 9 3.58z" />
        </svg>
      }
      sx={{ py: 1, borderColor: 'divider' }}
    >
      Continue with Google
    </Button>
  );
}
